export const DATA_CY_STREAM_WIDGET_NAVIGATION = 'stream-widget-navigation';
